module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAASCAYAAAC9+TVUAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAB/SURBVDhP7ZMxDoAgEAQHKy0o/JdPsuZJvIWGJ1iZaGOCcmJlI0JlnOTg2GQ3HAkqHFBIk/Yi5CbLAtZC2yb1AesKwwBddxxiiHNxpPzyPrpDkHGUims+l69eSCl/yJ0vhmyb9NlcPvmA0wTGgNan+IR5hnGEvk8hSX9NhTeBHVoJSUufxVNWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/images/node-icons/demand-node.png
// module id = 980
// module chunks = 0